export default "__VITE_ASSET__CYeprKYZ__"